<template lang="pug">
  b-modal#assignPageFunction(
  ref="assignPageFunction"
  :title="pageId"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  body-class="p-0"
  border
  @ok="done"
  @cancel="cancel"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit" style="overflow: hidden scroll; height: 30vh;").p-0.m-0.xps
      b-list-group(flush)
        b-list-group-item(
          v-for="pageFunctionInfo in pageFunctionList"
          :data="pageFunctionInfo"
          :key="pageFunctionInfo.function_id"
          v-if="!loading"
          ).d-flex.flex-nowrap.px-3.py-2
          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
            input.switch-input(type="checkbox" v-model="selectedFunctions" :value="pageFunctionInfo.function_id")
            span.switch-slider(:data-checked='$t("ui.on")' :data-unchecked='$t("ui.off")')
          div.ml-3.align-self-center {{ pageFunctionInfo.function_name }}
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    pageId: "",
    pageName: ""
  },
  data() {
    return {
      pageFunctionList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {},
  methods: {
    getPageFunctionList: function() {
      this.loading = true;
      this.selectedFunctions = [];
      let url = config.pageFunctionListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.function,
        target_page_id: this.pageId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageFunctionList = response.data.tbl_page_function_list;

                this.loading = false;

                for (var i = 0; i < this.pageFunctionList.length; i++) {
                  if (this.pageFunctionList[i].allow == 1) {
                    this.selectedFunctions.push(this.pageFunctionList[i].function_id);
                  }
                }
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "assign_functions", this.feedback.status);
                this.$refs.assignPageFunction.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.system"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.system"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    done: function(evt) {
      evt.preventDefault();

      if (this.selectedFunctions.length <= 0) {
        this.feedback.success = false;
        this.feedback.status = this.$t("targetFunctionIdRequired");
        return;
      }

      this.setPageFunction();
    },
    shown: function() {
      this.getPageFunctionList();
    },
    setPageFunction: function() {
      let url = config.editPageFunctionUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.function,
        target_function_id: this.selectedFunctions.toString(),
        target_page_id: this.pageId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.assignPageFunction.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "assign_functions", this.feedback.status);
                this.$refs.assignPageFunction.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.system"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.system"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    cancel: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    }
  }
};
</script>
